import React, { Component } from "react";
import Ability from "./Ability";
import Toggle from "react-toggle";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import "./css/AbilitySpread.css";
import "./css/react-toggle.css";

export default class AbilitySpread extends Component {
  state = {
    selectedAbility: 0,
    isRoyale: false
  };

  selectAbility = index => () => {
    this.setState({
      selectedAbility: index
    });
  };
  render() {
    const abilities = [...this.props.abilities];

    const type = 0.5,
      radius = "20em",
      start = 362.5,
      numberOfElements =
        this.props.abilities.length -
        (!this.props.toggle ? 1 : this.state.isRoyale ? 1 : 3),
      slice = (350 * type) / numberOfElements;

    return (
      <div className="abilitySpread">
        <img
          className="abilitySpread-background"
          draggable={false}
          src={this.props.image}
          alt="ability_background"
        />

        <div className="abilitySpread-content">
          {this.props.toggle ? (
            <div className="game-switcher">
              <img
                style = {
                  this.state.isRoyale
                  ? { opacity: "0.5" }
                  : { opacity: "1" }
                }
                id="reactToggleImg--Arena"
                draggable={false}
                className="reactToggleImg"
                alt="toggle"
                src="https://cdn.battlerite.com/www3/images/static/logos/logo-small.png"
              />
              <span
                style={
                  this.state.isRoyale
                    ? { color: "#784f29" }
                    : { color: "#fa8c25" }
                }
                
              >
                Arena
              </span>
              <Toggle
                defaultChecked={this.state.isRoyale}
                icons={false}
                className={
                  this.state.isRoyale
                  ? "react-toggle-thumb--royale"
                  : "react-toggle-thumb--arena"
                }
                onChange={() => {
                  this.setState({
                    isRoyale: !this.state.isRoyale,
                    selectedAbility:
                      this.state.selectedAbility > 6
                        ? 6
                        : this.state.selectedAbility
                  });
                  this.props.toggleGame();
                }}
              />
              <img
                style = {
                  this.state.isRoyale
                  ? { opacity: "1" }
                  : { opacity: "0.5" }
                }
                id="reactToggleImg--Royale"
                className="reactToggleImg"
                draggable={false}
                alt="toggle"
                src="https://cdn.battlerite.com/www3/images/static/logos/royale_wyrm_withshadow.png"
              />
              <span
                style={
                  this.state.isRoyale
                  ? { color: "#3ad3fe" }
                  : { color: "#1c6b83" }
                }
              >
                Royale
              </span>
            </div>
          ) : null}

          <div className="ability-text" key={this.state.selectedAbility}>
            <ReactCSSTransitionGroup
              transitionName="updateFade"
              transitionEnterTimeout={500}
              transitionLeave={false}
              transitionLeaveTimeout={500}
              transitionAppear={true}
              transitionAppearTimeout={500}
            >
              <div
                className="ability-text-content"
                key={abilities[this.state.selectedAbility].description}
              >
                <h1>
                  {abilities[this.state.selectedAbility].name.toUpperCase()}
                </h1>
                <p>{abilities[this.state.selectedAbility].description}</p>
              </div>
            </ReactCSSTransitionGroup>
          </div>

          <div className="ability-images">
            {this.props.abilities.map((ability, index) => {
              const rotate = slice * index + start;
              const rotateReverse = rotate * -1;
              const style = {
                transform:
                  index === abilities.length - 2 &&
                  (!this.state.isRoyale && this.props.toggle)
                    ? `rotate(${60}deg) translate(${"27em"}) rotate(${-60}deg)`
                    : index === abilities.length - 1 &&
                      (!this.state.isRoyale && this.props.toggle)
                    ? `rotate(${90}deg) translate(${"27em"}) rotate(${-90}deg)`
                    : `rotate(${rotate}deg) translate(${radius}) rotate(${rotateReverse}deg)`
              };

              return (
                <Ability
                  selectAbility={this.selectAbility(index)}
                  key={index}
                  style={style}
                  ability={ability}
                  active={this.state.selectedAbility === index}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
